export default __webpack_public_path__ + "assets/images/0920744e3195935b54d56b2eac739dc2.png";